import { MapMarkerRemoveVariantIcon } from './MapMarkerRemoveVariantIcon';

/**
 * author: GreenTurtwig
 * id D19361A0-41AB-4E11-B4D4-AE50D42B3B2C
 * name map-marker-remove-variant
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-remove-variant.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const LocationRemoveVariantOutlineIcon = MapMarkerRemoveVariantIcon;
export default LocationRemoveVariantOutlineIcon